export default {
  data() {
    return {}
  },
  mixins  : [],
  computed: {
    appCatalogs() {
      return this.appActiveCatalogs || []
    },
    appDefaultCatalog() {
      return this.appCatalogs.find(catalog => !!catalog.Default) || null
    },

    userCatalogs() {
      const userCatalogs = (this.posUser?.Settings?.AllUsers?.Catalogs || []).map(cid => parseInt(cid))
      return this.appCatalogs.filter(catalog => userCatalogs.includes(catalog.Id))
    },
    userDefaultCatalog() {
      const catalogId = parseInt(this.posUser?.Settings?.AllUsers?.DefaultCatalog ?? 0)
      const firstCatalog = this.userCatalogs.length > 0 ? this.userCatalogs[0] : null

      return this.userCatalogs.find(catalog => catalog.Id === catalogId) || firstCatalog || null
    },

    useUserCatalogs() {
      return this.userCatalogs.length > 0 && !this.userIsWaiter
    },

    activeCatalogs() {
      return this.useUserCatalogs ? this.userCatalogs : this.appCatalogs
    },

    defaultCatalog() {
      return this.useUserCatalogs ? this.userDefaultCatalog : this.appDefaultCatalog
    },

    sourceTypeActiveCatalogs() {
      const selectedSourceType = parseInt(this.posCart?.SourceTypeId || this.appConfig?.SOURCE_TYPES?.DEFAULT?.POS?.source_type_id || 5)
      const catalogs = this.activeCatalogs.filter(catalog => catalog.SourceTypes.includes(selectedSourceType)) || []
      return catalogs || []
    },

    sourceTypeHasMultipleCatalogs() {
      return this.sourceTypeActiveCatalogs.length > 1
    }
  }
}
